import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';

function ValuePropCard({ icon, headline, copy, linkText, linkUrl }) {
  return (
    <Card className="h-full hover:shadow-lg transition-shadow duration-300">
      <CardContent className="p-32 text-center h-full flex flex-col">
        <Box className="mb-24">
          {icon}
        </Box>
        <Typography variant="h5" className="mb-16 font-semibold text-center">
          {headline}
        </Typography>
        <Typography variant="body1" className="mb-24 text-gray-600 flex-grow">
          {copy}
        </Typography>
        {linkText && linkUrl && (
          <Typography 
            component={Link}
            to={linkUrl}
            className="text-blue-600 hover:text-blue-800 font-medium mt-auto"
          >
            {linkText} →
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default ValuePropCard;